import React from 'react';
import { Message } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';

function ForbiddenPage() {
  const { t } = useTranslation();
  return (
    <Message
      negative
      icon="dont"
      header={t('401.error.title')}
      content={t('401.error.description')}
    />
  );
}

export default ForbiddenPage;
